var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLightning = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.65884 1H4.76998C4.56856 1 4.38681 1.12086 4.3089 1.3066L1.29085 8.50172C1.15265 8.83121 1.39463 9.19512 1.75193 9.19512H3.59736C3.88406 9.19512 4.11205 9.43571 4.09664 9.722L3.90355 13.3086C3.87677 13.8062 4.51476 14.0325 4.80748 13.6292L10.4239 5.89127C10.6638 5.56073 10.4277 5.09756 10.0193 5.09756H8.34116C7.97697 5.09756 7.73496 4.72068 7.88649 4.38951L9.11351 1.70805C9.26504 1.37688 9.02303 1 8.65884 1Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLightning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lightning.8e1d0de4d253fcd5572af0fabc2ac3be.svg";